/**
 * This component is used to prevent agents from accessing routes
 * that only work for clients or anonymous users.
 * It should only be applied in public routes
 */

import React, { ReactElement } from "react";

import { IS_BROWSER } from "@config/consts";
import { PATHS, ROUTES } from "@config/app.routing";

import { langFromPathname } from "@services/LangFromPathname";

import { useAuth } from "@hooks/useAuth";
import { useLocalisation } from "@hooks/useLocalisation";

interface Props {
  children: React.ReactNode;
}

const AgentGuard = (props: Props): ReactElement | null => {
  const { language } = useLocalisation();
  const { isUserAgent, isUserAdmin } = useAuth();

  const resolvedLanguage = language || langFromPathname();
  const isWindowAvailable = IS_BROWSER;

  if (isUserAgent && isWindowAvailable && !isUserAdmin) {
    window.location.href = `/${resolvedLanguage}${PATHS.AGENT_APP}#${ROUTES.AGENT_MY_CLEANINGS}`;
    return null;
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};

export { AgentGuard };

AgentGuard.displayName = "AgentGuard";
